import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Component, forwardRef, Input } from "@angular/core";

@Component({
    selector: 'checkbox-group',
    template: `
        <div style="display:flex">
            <ng-content></ng-content>
        </div>
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckBoxGroupComponent),
            multi: true
        }
    ]
})
export class CheckBoxGroupComponent implements ControlValueAccessor {

    private _value: any;
    private change = Function;
    private touched = Function;

    constructor() { }


    get value() {
        return this._value;
    }
    set value(val: any) {
        if (this._value != val) {
            this._value = val;
            this.change(val);
        }
    }

    writeValue(val: any): void {
        this._value = val;
    }

    registerOnChange(fn: any): void {
        this.change = fn;
    }

    registerOnTouched(fn: any): void {
        this.touched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {

    }

    addOrRemove(value: any) {
        if (this.contains(value)) {
            this.remove(value);
        } else {
            this.add(value);
        }
    }

    contains(value: any): boolean {
        if (this._value instanceof Array) {
            return this._value.indexOf(value) > -1;
        } else if (!!this._value) {
            return this._value === value;
        }

        return false;
    }

    private add(value: any) {
        if (!this.contains(value)) {
            if (this._value instanceof Array) {
                this._value.push(value);
            } else {
                this._value = [value];
            }
            this.change(this._value);
        }
    }

    private remove(value: any) {
        const index = this._value.indexOf(value);
        if (!this._value || index < 0) {
            return;
        }

        this._value.splice(index, 1);
        this.change(this._value);
    }


}